// <GENERATED-CODE>
// Generated from Java using 'npm run generate:ts'

const WORKBOOK_SETTINGS_KEY_TO_PERSISTENCE_KEY = {
  WORKBOOK_PRINT_HEADER_NAME: 'workbook.printHeader.name',
  WORKBOOK_SIMPLIFIED_DESIGN_ENABLED: 'workbook.simplified.design.enabled',
  WORKBOOK_SIMPLIFIED_VIEW_LAYOUT_ENABLED: 'workbook.simplified.view.layout.enabled',
  WORKBOOK_SIMPLIFIED_DATA_VIEW_CONTENT_ENABLED: 'workbook.simplified.data.view.content.enabled'
} as const;

/** @see net/disy/cadenza/workbook/model/WorkbookSettingsKey.java */
export type WorkbookSettingsKey = keyof typeof WORKBOOK_SETTINGS_KEY_TO_PERSISTENCE_KEY;

export const WorkbookSettingsKey = {
  values: Object.keys(WORKBOOK_SETTINGS_KEY_TO_PERSISTENCE_KEY) as readonly WorkbookSettingsKey[],
  toPersistenceKey: (value: WorkbookSettingsKey) => WORKBOOK_SETTINGS_KEY_TO_PERSISTENCE_KEY[value],
  fromPersistenceKey: (persistenceKey: string) => {
    const value = WorkbookSettingsKey.values.find(key => WORKBOOK_SETTINGS_KEY_TO_PERSISTENCE_KEY[key] === persistenceKey);
    if (!value) { throw new Error(`No WorkbookSettingsKey for key: ${persistenceKey}`); }
    return value;
  }
} as const;

// </GENERATED-CODE>
